import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { EntityDto, EntityDtoPOST } from '@dto';
import { RequestMethodEnum, RequestOptions } from '@model';
import { GenericService } from './generic.service';

const ENTITIES_ENDPOINT = 'api/v1/entities';

@Injectable()
export class EntityService {
  private _entities: EntityDto[];
  get entites(): EntityDto[] {
    return this._entities;
  }

  constructor(private resourceService: GenericService) {}

  entities$(): Observable<EntityDto[]> {
    const options: RequestOptions<undefined, EntityDto[]> = {
      method: RequestMethodEnum.GET,
      path: ENTITIES_ENDPOINT,
    };
    return this.resourceService.request(options).pipe(
      tap((entites: EntityDto[]) => {
        this._entities = entites;
      }),
    );
  }

  createEntity$(entity: EntityDtoPOST): Observable<EntityDto> {
    const options: RequestOptions<EntityDtoPOST, EntityDto> = {
      body: entity,
      method: RequestMethodEnum.POST,
      path: ENTITIES_ENDPOINT,
    };
    return this.resourceService.request(options).pipe(
      tap((entity: EntityDto) => {
        this._entities.push(entity);
      }),
    );
  }
}
